









































































































































































import AxHeader from "@/components/Header.vue";
import { Component, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Family, User } from "@/store/types";
import { Modal } from "iview";
import i18n from "@/locale";
const namespace: string = "profile";

interface OptionObject {
  text: string;
  value: any;
}

interface CourseObject {
  title: string;
  description: string;
  level: number;
  link: string;
  icon: string;
  skills: number[];
  age: number;
  type: string;
  pros: ProObject[];
  info: number;
}

interface ProObject {
  title: string;
  icon: string;
}

@Component({
  components: { AxHeader }
})
export default class Course extends Vue {
  @Getter("family", { namespace }) private family!: Family;
  @Getter("selectChild", { namespace }) private selectChild!: User;
  @Action("selectChild", { namespace }) private setSelectChild;

  @Getter("isAuthenticated", { namespace }) private isAuthenticated!: User;
  @Action("getFamily", { namespace }) private getFamily;

  private paymodel: boolean = false;
  private age = 0;
  private ageOptions: OptionObject[] = [
    {
      text: "无限制",
      value: 0
    },
    {
      text: "6岁以上",
      value: 6
    },
    {
      text: "8岁以上",
      value: 8
    },
    {
      text: "10岁以上",
      value: 10
    }
  ];
  private level = 0;
  private levelOptions: OptionObject[] = [
    {
      text: "无限制",
      value: 0
    }
  ];
  private courses: CourseObject[] = [];
  private courseData: CourseObject[] = [
    { title: ">>科技夏令营",
      description: "夏令营学生将有机会参与CCTV《爱拼才会赢·编程未来星》电视节目录制！",
      level: 1,
      link: "",
      icon: "",
      skills: [1, 4, 5],
      age: 6,
      type: "camp",
      pros: [
        {title: "科技产品整体运作能力", icon: "summer_00.png"},
        {title: "代码编程能力", icon: "summer_01.png"},
        {title: "演讲能力", icon: "summer_02.png"}
      ],
      info: 0
    },
    {
      title: "拼图游戏",
      description: "点击鼠标可以移动代码模块，将其拼接在一起。请为每个动物添加照片，并为其选择正确的腿的数量，以及对应的身体特征。如：猫有4条腿，特征是胡须和皮毛。",
      level: 1,
      link: "https://block.axiomacademy.cn/puzzle.html?lang=zh-hans",
      icon: "",
      skills: [1, 2, 3],
      age: 6,
      type: "free",
      pros: [
        {title: "逻辑能力", icon: "puzzle_00.png"},
        {title: "基础编程思维", icon: "puzzle_01.png"},
        {title: "探索发现能力", icon: "puzzle_02.png"}
      ],
      info: 1
    },
    {
      title: "移动迷宫",
      description: "向左转还是向右转？走在路上，你能分清楚你的左右方向吗？那么，其他人的左右方向你能分清楚吗？帮助电脑上的玩家判断方向，走出迷宫吧！当他重复的走相同的路形时，你能用最少的代码模拟他的行走路线吗？",
      level: 1,
      link: "https://block.axiomacademy.cn/maze.html?lang=zh-hans",
      icon: "",
      skills: [1, 5, 6],
      age: 7,
      type: "pay",
      pros: [
        {title: "逻辑能力", icon: "maze_00.png"},
        {title: "换位思考能力", icon: "maze_01.png"},
        {title: "分析问题解决问题能力", icon: "maze_02.png"}
      ],
      info: 2
    },
    {
      title: "小鸟觅食记",
      description: "小鸟每天的日常就是出去捉虫子填饱肚子，然后飞回家里，但是路途也不是一帆风顺的，有时候会捉不到虫子，路途也会遇到很多阻碍，你能帮助小鸟冲破重重阻碍，顺利捉到虫子并送它回家吗？",
      level: 1,
      link: "https://block.axiomacademy.cn/bird.html?lang=zh-hans",
      icon: "",
      skills: [1, 4, 13],
      age: 8,
      type: "pay",
      pros: [
        {title: "逻辑能力", icon: "bird_00.png"},
        {title: "数学能力", icon: "bird_01.png"},
        {title: "抗挫折能力", icon: "bird_02.png"}
      ],
      info: 3
    },
    {
      title: "小小画家",
      description: "你知道你平时看的动画片是如何画出来的吗？除了画笔以外，我们还可以用代码来绘画啦，神奇吧，快来尝试用代码来画出正方形、小星星、月亮、夜空等画面吧！",
      level: 2,
      link: "https://block.axiomacademy.cn/turtle.html?lang=zh-hans",
      icon: "",
      skills: [7, 8, 9],
      age: 8,
      type: "pay",
      pros: [
        {title: "跨界知识运用能力", icon: "turtle_00.png"},
        {title: "几何能力", icon: "turtle_01.png"},
        {title: "艺术想象力", icon: "turtle_02.png"}
      ],
      info: 4
    },
    {
      title: "小小作曲家",
      description: "哆瑞咪发嗦啦西~我们的音乐可以用数字1234567表示，也可以用音符的高低位置来表示。一段优美旋律的音符，高高低低通常都会有一定的规律，你能把音乐的规律用代码写出来吗？",
      level: 2,
      link: "https://block.axiomacademy.cn/music.html?lang=zh-hans",
      icon: "",
      skills: [1, 10, 11],
      age: 9,
      type: "pay",
      pros: [
        {title: "逻辑能力", icon: "music_00.png"},
        {title: "探索创新能力", icon: "music_01.png"},
        {title: "音乐感知力", icon: "music_02.png"}
      ],
      info: 5
    },
    {
      title: "池塘大作战",
      description: "炎热的夏日，凉爽的池塘是小鸭子们的必争之地，一只霸道的小红鸭占领了大片的空间，为了争取更多的游泳空间，池塘里的小黄鸭对小红鸭发起了进攻，你能帮助小黄鸭赶走小红鸭吗？",
      level: 3,
      link: "https://block.axiomacademy.cn/pond-tutor.html?lang=zh-hans",
      icon: "",
      skills: [12, 4, 13],
      age: 10,
      type: "pay",
      pros: [
        {title: "代码编程能力", icon: "pond_00.png"},
        {title: "数学能力", icon: "pond_01.png"},
        {title: "抗挫折能力", icon: "pond_02.png"}
      ],
      info: 6
    }
  ];
  private async mounted(): Promise<void> {
    for (let i = 1; i < 4; i++) {
      this.levelOptions.push({ text: `Level ${i}`, value: i });
    }
    this.filterCourse();
    await this.getFamily(this.family.id);

    this.family.members.forEach((user: User) => {
          if (user.id === this.selectChild.id) {
              this.setSelectChild(user);
          }
    });
  }
  private goBlock(item: CourseObject) {
    if (item.type === "pay" && (!this.selectChild || !this.selectChild.hasPaid)) {
      this.paymodel = true;
      return;
    }
    if (item.info > 2) {
      this.paymodel = true;
      return;
    }
    window.location.href = item.link;
  }
  private filterCourse(): void {
    let temp: CourseObject[] = [];
    const level = this.level;
    const age = this.age;
    this.courseData.map(item => {
      if (level !== 0) {
        if (age !== 0) {
          // level != 0 && age != 0
          if (item.level === level && age <= item.age) {
            temp.push(item);
          }
        } else {
          // level != null && age == null
          if (item.level === level) {
            temp.push(item);
          }
        }
      } else {
        if (age !== 0) {
          // level = null && age != null
          if (age <= item.age) {
            temp.push(item);
          }
        } else {
          // level == null && age == null
          temp = this.courseData;
        }
      }
    });
    this.courses = temp;
  }
}
